import React, { useImperativeHandle, useState } from "react";
import { StyleSheet, View } from "react-native";
import { useTranslation } from "@luna-restaurant/i18n";
import { useCustomTheme } from "../hooks/useCustomTheme";
import { Button } from "./Button";
import { Icon } from "./Icon";
import { ThemedText } from "./ThemedText";
export const ReportNotification = ({ noticeText, onClicked, style, slim, ref, }) => {
    const { colors, fonts } = useCustomTheme();
    const { t } = useTranslation();
    const [successMessage, setSuccessMessage] = useState(null);
    useImperativeHandle(ref, () => ({
        showSuccess: (message) => {
            setSuccessMessage(message ?? t("common.lunaWasInformed"));
        },
        hideSuccess: () => {
            setSuccessMessage(null);
        },
    }));
    return (<View style={[styles.reportContainer, style]}>
      {successMessage ? (<View style={styles.successContainer}>
          <Icon size={28} iconSet="material-community" icon="information"/>
          <ThemedText type="subtitle">{successMessage}</ThemedText>
        </View>) : (<>
          <ThemedText type="subtitle">{noticeText}</ThemedText>
          <Button onPress={onClicked} buttonText={t("common.informLuna")} buttonStyle={[
                styles.reportButton,
                {
                    backgroundColor: colors.background,
                    borderColor: colors.notification,
                },
                slim && styles.reportButtonSlim,
            ]} buttonTextStyle={{ ...fonts.bold }}/>
        </>)}
    </View>);
};
ReportNotification.displayName = "ReportNotification";
const styles = StyleSheet.create({
    successContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
    },
    reportContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-evenly",
    },
    reportButton: {
        borderWidth: 2,
    },
    reportButtonSlim: {
        height: 60,
    },
});
//# sourceMappingURL=ReportNotification.js.map